import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year2/Autumn/AdditionAndSubtraction/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'AdditionAndSubtraction',
  field: 'Number',
  weeks: [5, 9],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Autumn/AdditionAndSubtraction/1BondsTo10" */ './1BondsTo10'
        )
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Autumn/AdditionAndSubtraction/2FactFamiliesAdditionSubtractionBondsWithin20" */ './2FactFamiliesAdditionSubtractionBondsWithin20'
        )
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Autumn/AdditionAndSubtraction/3RelatedFacts" */ './3RelatedFacts'
        )
    }),
    // Step 4
    newSmallStepContent({
      ...BlockModel.smallSteps[3],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Autumn/AdditionAndSubtraction/4BondsTo100Tens" */ './4BondsTo100Tens'
        )
    }),
    // Step 5
    newSmallStepContent({
      ...BlockModel.smallSteps[4],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Autumn/AdditionAndSubtraction/5AddAndSubtract1s" */ './5AddAndSubtract1s'
        )
    }),
    // Step 6
    newSmallStepContent({
      ...BlockModel.smallSteps[5],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Autumn/AdditionAndSubtraction/6AddByMaking10" */ './6AddByMaking10'
        )
    }),
    // Step 7
    newSmallStepContent({
      ...BlockModel.smallSteps[6],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Autumn/AdditionAndSubtraction/7AddThree1DigitNumbers" */ './7AddThree1DigitNumbers'
        )
    }),
    // Step 8
    newSmallStepContent({
      ...BlockModel.smallSteps[7],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Autumn/AdditionAndSubtraction/8AddToTheNext10" */ './8AddToTheNext10'
        )
    }),
    // Step 9
    newSmallStepContent({
      ...BlockModel.smallSteps[8],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Autumn/AdditionAndSubtraction/9AddAcrossA10" */ './9AddAcrossA10'
        )
    }),
    // Step 10
    newSmallStepContent({
      ...BlockModel.smallSteps[9],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Autumn/AdditionAndSubtraction/10SubtractAcross10" */ './10SubtractAcross10'
        )
    }),
    // Step 11
    newSmallStepContent({
      ...BlockModel.smallSteps[10],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Autumn/AdditionAndSubtraction/11SubtractFromA10" */ './11SubtractFromA10'
        )
    }),
    // Step 12
    newSmallStepContent({
      ...BlockModel.smallSteps[11],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Autumn/AdditionAndSubtraction/12SubtractA1DigitNumberFromA2DigitNumberAcrossA10" */ './12SubtractA1DigitNumberFromA2DigitNumberAcrossA10'
        )
    }),
    // Step 13
    newSmallStepContent({
      ...BlockModel.smallSteps[12],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Autumn/AdditionAndSubtraction/13TenMoreTenLess" */ './13TenMoreTenLess'
        )
    }),
    // Step 14
    newSmallStepContent({
      ...BlockModel.smallSteps[13],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Autumn/AdditionAndSubtraction/14AddAndSubtract10s" */ './14AddAndSubtract10s'
        )
    }),
    // Step 15
    newSmallStepContent({
      ...BlockModel.smallSteps[14],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Autumn/AdditionAndSubtraction/15AddTwo2DigitNumbersNotAcrossA10" */ './15AddTwo2DigitNumbersNotAcrossA10'
        )
    }),
    // Step 16
    newSmallStepContent({
      ...BlockModel.smallSteps[15],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Autumn/AdditionAndSubtraction/16AddTwo2DigitNumbersAcrossA10" */ './16AddTwo2DigitNumbersAcrossA10'
        )
    }),
    // Step 17
    newSmallStepContent({
      ...BlockModel.smallSteps[16],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Autumn/AdditionAndSubtraction/17SubtractTwo2DigitNumbersNotAcrossA10" */ './17SubtractTwo2DigitNumbersNotAcrossA10'
        )
    }),
    // Step 18
    newSmallStepContent({
      ...BlockModel.smallSteps[17],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Autumn/AdditionAndSubtraction/18SubtractTwo2DigitNumbersAcrossA10" */ './18SubtractTwo2DigitNumbersAcrossA10'
        )
    }),
    // Step 19
    newSmallStepContent({
      ...BlockModel.smallSteps[18],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Autumn/AdditionAndSubtraction/19MixedAdditionAndSubtraction" */ './19MixedAdditionAndSubtraction'
        )
    }),
    // Step 20
    newSmallStepContent({
      ...BlockModel.smallSteps[19],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Autumn/AdditionAndSubtraction/20CompareNumberSentences" */ './20CompareNumberSentences'
        )
    }),
    // Step 21
    newSmallStepContent({
      ...BlockModel.smallSteps[20],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Autumn/AdditionAndSubtraction/21MissingNumberProblems" */ './21MissingNumberProblems'
        )
    })
  ]
});
export default Block;
